import Box from '@redbubble/design-system/src/Box';
import Card from '@redbubble/design-system/src/Card';
import * as constants from '@redbubble/design-system/src/constants';
import Image from '@redbubble/design-system/src/Image';
import Text from '@redbubble/design-system/src/Text';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import React from 'react';
import emailImage from '../email.svg';
import purchaseImage from '../purchase.svg';
import shareImage from '../share.svg';
import styles from './HowItWorks.module.scss';

const messages = defineMessages({
  howItWorks: {
    defaultMessage: 'How it works',
  },
  purchaseTitle: {
    defaultMessage: 'Purchase a gift card',
  },
  purchaseBlurb: {
    defaultMessage: 'It’s quick, easy, and doesn’t require leaving your couch.',
  },
  emailTitle: {
    defaultMessage: 'Check your email',
  },
  emailBlurb: {
    defaultMessage:
      'We’ll send the digital gift card to the email address you provide at checkout.',
  },
  shareTitle: {
    defaultMessage: 'Give the gift of Redbubble',
  },
  shareBlurb: {
    defaultMessage:
      'Share the gift card however you like. Email it, text it, or print it out and stick it in a greeting card.',
  },
});

interface HowItWorksProps {
  isDesktop: boolean;
}

export const HowItWorks: React.FC<HowItWorksProps> = ({ isDesktop }) => {
  const intl = useIntl();

  const howItWorksCollection = [
    {
      topic: intl.formatMessage(messages.purchaseTitle),
      blurb: intl.formatMessage(messages.purchaseBlurb),
      image: purchaseImage.src,
    },
    {
      topic: intl.formatMessage(messages.emailTitle),
      blurb: intl.formatMessage(messages.emailBlurb),
      image: emailImage.src,
    },
    {
      topic: intl.formatMessage(messages.shareTitle),
      blurb: intl.formatMessage(messages.shareBlurb),
      image: shareImage.src,
    },
  ];

  return (
    <>
      <Box marginTop="xl" style={{ textAlign: 'center' }}>
        <Text type="display1">{intl.formatMessage(messages.howItWorks)}</Text>
      </Box>

      <Box marginTop="m" className={styles.howItWorks}>
        {howItWorksCollection.map((entry) => (
          <Box
            margin="m"
            display="flex"
            flex="1"
            marginBottom="xl"
            className={styles.collectionContainer}
          >
            <Card fluid elevation={constants.ELEVATION_MEDIUM}>
              <Box padding="xl" className={styles.card}>
                <Image
                  size={isDesktop ? constants.LARGE : constants.MEDIUM}
                  src={entry.image}
                />
                <Box marginBottom="xl" />
                <Text display="block" type="display3">
                  {entry.topic}
                </Text>
                <Box marginBottom="m" />
                <Text display="block" type="body">
                  {entry.blurb}
                </Text>
              </Box>
            </Card>
          </Box>
        ))}
      </Box>
    </>
  );
};
